import { CountryDto } from "@cradua/data";
import { createReducer, on, Action } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";

import * as StakeholderReferenceActions from "./stakeholderreference.actions";

export const STAKEHOLDERREFERENCEGROUP_FEATURE_KEY =
  "stakeholderreferencegroup";

export interface StakeholderReferenceGroupState extends EntityState<any> {
  selectedStakeholderReferenceGroupId?: string | number; // which Country record has been selected
  loaded: boolean; // has the Country list been loaded
  error?: string | null; // last none error (if any)
}

export interface StakeholderReferenceGroupPartialState {
  readonly [STAKEHOLDERREFERENCEGROUP_FEATURE_KEY]:
    StakeholderReferenceGroupState;
}

export const stakeholderreferenceGroupAdapter: EntityAdapter<any> =
  createEntityAdapter<
    any
  >({
    selectId: (stakeholderreferencegroup) => stakeholderreferencegroup.id,
    sortComparer: false,
  });

export const initialGroupState: StakeholderReferenceGroupState =
  stakeholderreferenceGroupAdapter.getInitialState(
    {
      // set initial required properties
      loaded: false,
      error: null,
      selectedStakeholderReferenceGroupId: null,
    },
  );

const stakeholderreferenceGroupReducer = createReducer(
  initialGroupState,
  on(
    StakeholderReferenceActions.loadByTypeStakeholderReferenceGroup,
    (state, inputtype) => ({
      ...state,
      loaded: true,
      error: null,
    }),
  ),
  on(
    StakeholderReferenceActions.loadByTypeStakeholderReferenceGroupSuccess,
    (state, { stakeholderreferencegroup }) =>
      stakeholderreferenceGroupAdapter.addAll(stakeholderreferencegroup, {
        ...state,
        loaded: false,
      }),
  ),
  on(
    StakeholderReferenceActions.loadByTypeStakeholderReferenceGroupFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    }),
  ),
);

export function reducer(
  state: StakeholderReferenceGroupState | undefined,
  action: Action,
) {
  return stakeholderreferenceGroupReducer(state, action);
}
